import { config } from '../../../config';
import {
  getStoredToken,
  sessionChecker,
} from '../../../services/user/SessionChecker';
import { parseFetchError } from '../../../utils/http';
import { updateSystemSettings } from './LocalConfigParam';

const home = data => {
  const token = getStoredToken();
  if (token) {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          config.api_routes.prefix +
          config.api_routes.modules.config.prefix +
          config.api_routes.modules.config.services.home;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });
        const dataOut = await res.json();
        sessionChecker(dataOut);
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return new Promise(async (resolve, reject) => {
      document.location.href = config.appURI;
      reject({
        respCode: -1,
        message:
          'No ha iniciado sesión por lo tanto no puede ingresar a esta opción',
      });
    });
  }
};

const addParam = data => {
  const token = getStoredToken();
  if (token && token !== 'undefined') {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          config.api_routes.prefix +
          config.api_routes.modules.config.prefix +
          config.api_routes.modules.config.services.addParam;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });
        const dataOut = await res.json();
        sessionChecker(dataOut);
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return new Promise(async (resolve, reject) => {
      document.location.href = config.appURI;
      reject({
        respCode: -1,
        message:
          'No ha iniciado sesión por lo tanto no puede ingresar a esta opción',
      });
    });
  }
};

const editParam = id => {
  const token = getStoredToken();
  if (token && token !== 'undefined') {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          config.api_routes.prefix +
          config.api_routes.modules.config.prefix +
          config.api_routes.modules.config.services.getParam;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({ id }),
        });
        const dataOut = await res.json();
        sessionChecker(dataOut);
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return new Promise(async (resolve, reject) => {
      document.location.href = config.appURI;
      reject({
        respCode: -1,
        message:
          'No ha iniciado sesión por lo tanto no puede ingresar a esta opción',
      });
    });
  }
};

const updateParam = data => {
  const token = getStoredToken();
  if (token && token !== 'undefined') {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          config.api_routes.prefix +
          config.api_routes.modules.config.prefix +
          config.api_routes.modules.config.services.updateParam;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });
        const dataOut = await res.json();
        sessionChecker(dataOut);
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return new Promise(async (resolve, reject) => {
      document.location.href = config.appURI;
      reject({
        respCode: -1,
        message:
          'No ha iniciado sesión por lo tanto no puede ingresar a esta opción',
      });
    });
  }
};

const updateParamValue = data => {
  const token = getStoredToken();
  if (token && token !== 'undefined') {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          config.api_routes.prefix +
          config.api_routes.modules.config.prefix +
          config.api_routes.modules.config.services.updateParamValue;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });
        const dataOut = await res.json();
        sessionChecker(dataOut);
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return new Promise(async (resolve, reject) => {
      document.location.href = config.appURI;
      reject({
        respCode: -1,
        message:
          'No ha iniciado sesión por lo tanto no puede ingresar a esta opción',
      });
    });
  }
};

const deleteParam = data => {
  const token = getStoredToken();
  if (token && token !== 'undefined') {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          config.api_routes.prefix +
          config.api_routes.modules.config.prefix +
          config.api_routes.modules.config.services.deleteParam;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });
        const dataOut = await res.json();
        sessionChecker(dataOut);
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return new Promise(async (resolve, reject) => {
      document.location.href = config.appURI;
      reject({
        respCode: -1,
        message:
          'No ha iniciado sesión por lo tanto no puede ingresar a esta opción',
      });
    });
  }
};

const dashboard = data => {
  const token = getStoredToken();
  if (token) {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          config.api_routes.prefix +
          config.api_routes.modules.config.prefix +
          config.api_routes.modules.config.services.dashboard;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });
        const dataOut = await res.json();
        sessionChecker(dataOut);
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return new Promise(async (resolve, reject) => {
      document.location.href = config.appURI;
      reject({
        respCode: -1,
        message:
          'No ha iniciado sesión por lo tanto no puede ingresar a esta opción',
      });
    });
  }
};
const configClientParams = async () => {
  try {
    const serviceUrl =
      config.serverURL +
      config.api_routes.prefix +
      config.api_routes.modules.config.prefix +
      config.api_routes.modules.config.services.frontendInit;
    const res = await fetch(serviceUrl, {
      headers: {
        'Access-Control-Allow-Origin': config.serverDomain,
        'Access-Control-Allow-Headers':
          'Origin, X-Requested-With, Content-Type, Accept',
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      method: 'POST',
    }).catch(err => {
      console.log(err.response);
    });

    if (res && res.ok) {
      const dataOut = await res.json();
      if (dataOut.respCode === 0) {
        updateSystemSettings(dataOut.data.systemSettings);
      }
    }
  } catch (e) {
    console.log(parseFetchError(e));
  }
};

export {
  home,
  addParam,
  editParam,
  updateParam,
  updateParamValue,
  deleteParam,
  dashboard,
  configClientParams,
};
